import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Pagination } from '../../../models/pagination';
import { ImpuestoPorcentajeService } from '../../../services/impuesto-porcentaje.service';

@Component({
  selector: 'app-ice-modal',
  templateUrl: './ice-modal.component.html',
  styleUrls: ['./ice-modal.component.css'],
  providers: [
    ImpuestoPorcentajeService
  ]
})
export class IceModalComponent implements OnInit {
  public loading: boolean;
  @Input() impuesto_porcentaje_ice: any;
  @Output() sendImpuestoIce = new EventEmitter();

  public selectedRow: Number;
  public impuesto_porcentaje: any;
  public impuesto_renta: Array<any>;
  public pagination: Pagination;
  public busqueda: string;
  public format_decimal : string;
  constructor(
    public bsModalRef: BsModalRef,
    public impuestoporcentajeService: ImpuestoPorcentajeService,

  ) {
    this.loading = false;
    this.impuesto_renta = [];
    this.impuesto_porcentaje = {};
    this.pagination = new Pagination();
    this.busqueda = "";
    this.format_decimal = "0,0.00";
  }

  ngOnInit() {
    // this.impuesto_renta = this.impuesto_porcentaje_ice;
    let qs = "";
    let p1 = this.getImpuestoIce(qs);
    this.loading = true;
    Promise.all([p1]).then(
      res => this.loading = false,
      err => this.loading = false
    )
  }
  onSearch(event) {
    this.busqueda = event;
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.loading = true;
    let id = "";
    this.getImpuestoIce(qs).then(
      res => this.loading = false,
      err => this.loading = false
    );

  }
  getQs() {
    return "&q[descripcion]=" + this.busqueda + "&q[codigo]=" + this.busqueda;
  }
  getImpuestoIce(qs) {
    return new Promise((resolve, reject) => {
      this.impuestoporcentajeService.getAll("?page=" + this.pagination.current_page + "&per_page=10&impuesto_id=4&is_vigente=1" + qs).subscribe(
        res => {

          this.impuesto_renta = res.data;
          this.pagination.current_page = res.current_page;
          this.pagination.from = res.from;
          this.pagination.to = res.to;
          this.pagination.total = res.total;
          this.pagination.last_page = res.last_page;
          this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
          this.pagination.prev_disabled = this.pagination.current_page === 1;
          resolve();
        }, err => {
          reject(err);
        }
      );
    });

  }

  next() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page++;
    this.getImpuestoIce(qs);
  }

  prev() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page--;
    this.getImpuestoIce(qs);
  }

  first() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page = 1;
    this.getImpuestoIce(qs);
  }

  last() {
    let qs = "";
    if (this.busqueda != "") {
      qs = this.getQs();
    }
    this.pagination.current_page = this.pagination.last_page;
    this.getImpuestoIce(qs);
  }

  onSelectRow(impuesto_renta, i) {
    //Asignacion de fila
    this.selectedRow = i;
    //Asignacion de proveedor
    this.impuesto_porcentaje = impuesto_renta;
  }

  onDBLClick(impuesto_renta, i) {
    this.onSelectRow(impuesto_renta, i);
    this.onSubmit();
  }

  onSubmit() {
    //envía de objecto proveedor
    this.sendImpuestoIce.emit(this.impuesto_porcentaje);
    //Cierre de modal o componente
    this.bsModalRef.hide();
  }
  getIndexNumber(i) {
		return this.pagination.from + i;
  }

}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/ice-modal/ice-modal.component.ts